const StorageKey = {
    LONGIN_TYPE: "login_type",
    BITKUB_NEXT_AUTH: "bitkub_next_auth",
    BITKUB_NEXT_USER_INFO: "bitkub_next_user_info"
}

export default StorageKey;